import { render, staticRenderFns } from "./CourierRowAction.vue?vue&type=template&id=203f835e"
import script from "./CourierRowAction.vue?vue&type=script&lang=js"
export * from "./CourierRowAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports